/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCoth } from '../../factoriesAny.js';
export var cothDependencies = {
  BigNumberDependencies,
  typedDependencies,
  createCoth
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCoth.generated.js
// module id = QIMd
// module chunks = 3